import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useParams } from "react-router-dom";
import AssignRequest from "./AssignRequest";
import RejectRequest from "./RejectRequest";
import AcceptRequest from "./AcceptRequest";
import styles from "./styles";
import { FRIEND_TYPE } from "../../contants";

const REJECT = "reject";
const ACCEPT = "accept";

function PendingTab({
  firstTabTitle,
  secondTabTitle,
  onFinalSubmit,
  onFinalReject,
  selectedItem,
  onFinalAccept,
  refreshRemarks,
  pageType,
}) {
  // const [showReject, setShowReject] = useState(false);
  const { type } = useParams();

  const getComponent = () => {
    if (type === REJECT) {
      return (
        <RejectRequest
          onFinalSubmit={onFinalReject}
          selectedItem={selectedItem}
        />
      );
    }
    if (type === ACCEPT) {
      return (
        <AcceptRequest
          onFinalSubmit={onFinalAccept}
          selectedItem={selectedItem}
        />
      );
    }
    return (
      <AssignRequest
        onFinalSubmit={onFinalSubmit}
        selectedItem={selectedItem}
        refreshRemarks={refreshRemarks}
        pageType={pageType}
      />
    );
  };

  const getTitle = () => {
    if (type === REJECT) {
      return <Box style={styles.tab}>{secondTabTitle}</Box>;
    }
    if (type === ACCEPT) {
      return <Box style={styles.tab}>Accept</Box>;
    }
    return <Box style={styles.tab}>{firstTabTitle}</Box>;
  };

  return (
    <Box>
      <Box style={styles.container}>{getTitle()}</Box>
      <Box style={styles.main}>{getComponent()}</Box>
    </Box>
  );
}

const propTypes = {
  firstTabTitle: PropTypes.string.isRequired,
  secondTabTitle: PropTypes.string.isRequired,
  selectedItem: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onFinalSubmit: PropTypes.func.isRequired,
  onFinalReject: PropTypes.func.isRequired,
  onFinalAccept: PropTypes.func,
  refreshRemarks: PropTypes.func,
  pageType: PropTypes.string,
};
const defaultProps = {
  onFinalAccept: () => {},
  refreshRemarks: () => {},
  pageType: FRIEND_TYPE,
};

PendingTab.propTypes = propTypes;
PendingTab.defaultProps = defaultProps;

export default PendingTab;
